// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterWrapper_wrapper__MIx18"};